
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      showLogoutDialog: false
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    handleLogout() {
      this.showLogoutDialog = true;
    },
    cancelLogoutDialog() {
      this.showLogoutDialog = false;
    }
  }
};
